import { render, staticRenderFns } from "./PageACCESSIBILITY.vue?vue&type=template&id=2cbcbcdc&scoped=true"
import script from "./PageACCESSIBILITY.vue?vue&type=script&lang=js"
export * from "./PageACCESSIBILITY.vue?vue&type=script&lang=js"
import style0 from "./PageACCESSIBILITY.vue?vue&type=style&index=0&id=2cbcbcdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbcbcdc",
  null
  
)

export default component.exports